import { CEDE_CEXS } from "../cexs";

export const SUPPORTED_TOKENS_BY_CEX = {
  [CEDE_CEXS.COINBASE]: ["USDT", "BTC", "AVAX", "LINK", "ETH", "DOT"],
  [CEDE_CEXS.BINANCE]: ["USDT", "BTC", "AVAX", "LINK", "ETH", "BNB", "DOT"],
  [CEDE_CEXS.KRAKEN]: ["USDT", "BTC", "AVAX", "LINK", "ETH", "BNB", "DOT"],
  [CEDE_CEXS.KUCOIN]: ["USDT", "BTC", "AVAX", "LINK", "ETH", "BNB", "DOT"],
  [CEDE_CEXS.HTX]: ["USDT", "BTC", "AVAX", "LINK", "ETH", "BNB", "DOT"],
  [CEDE_CEXS.GATEIO]: ["USDT", "BTC", "AVAX", "LINK", "ETH", "BNB", "DOT"],
  [CEDE_CEXS.BITFINEX]: ["USDT", "BTC", "AVAX", "LINK", "ETH", "DOT"],
  [CEDE_CEXS.BYBIT]: ["USDT", "BTC", "AVAX", "LINK", "ETH", "DOT"],
  [CEDE_CEXS.BITGET]: ["USDT", "BTC", "AVAX", "LINK", "ETH", "DOT"],
  [CEDE_CEXS.BITSTAMP]: ["USDT", "BTC", "AVAX", "LINK", "ETH", "DOT"],
  [CEDE_CEXS.OKX]: ["USDT", "BTC", "AVAX", "LINK", "ETH", "DOT"],
  [CEDE_CEXS.BITMART]: ["USDT", "BTC", "AVAX", "LINK", "ETH", "DOT"],
  [CEDE_CEXS.MEXC]: ["USDT", "BTC", "AVAX", "LINK", "ETH", "DOT"],
};

export const MOCKED_TOKENS: [string, number][] = [
  ["USDT", 1],
  ["BTC", 0.000001],
  ["AVAX", 0.1],
  ["LINK", 0.1],
  ["ETH", 0.001],
  ["BNB", 0.01],
  ["DOT", 0.1],
];

/**
 * Mocked tokens balances ranges
 * In USD, should be between 100 and 1000
 */
export const MOCKED_TOKENS_BALANCES_RANGES: { [tokenSymbol: string]: [number, number] } = {
  USDT: [100, 1000],
  BTC: [0.0027, 0.027],
  AVAX: [5, 50],
  LINK: [7, 70],
  ETH: [0.049, 0.495],
  BNB: [0.44, 4.39],
  DOT: [19.4, 194],
};

export const MOCKED_DEVICE_ID = "fakeDeviceId";

export * from "./accounts";
export * from "./addressBook";
export * from "./exchange";
export * from "./markets";
export * from "./order";
export * from "./portfolio";
export * from "./prices";
export * from "./settings";
export * from "./transactions";
export * from "./vaults";
export * from "./supportedExchanges";
export * from "./networks";
export * from "./balances";
export * from "./whitelistedAddresses";
export * from "./campaign.factory";
export * from "./trade.factory";
export * from "./sdkOrder.factory";
export * from "./tradeV2.factory";
export * from "./sdkOrderV2.factory";
